import { render } from "./PostTypeTabs.vue?vue&type=template&id=8d780566&scoped=true"
import script from "./PostTypeTabs.vue?vue&type=script&lang=js"
export * from "./PostTypeTabs.vue?vue&type=script&lang=js"

import "./PostTypeTabs.vue?vue&type=style&index=0&id=8d780566&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d780566"]])

export default __exports__